// Saikrishna 27/10/2022 3075234474 Scheduling functionality -->  Reccurence Pattern- daily(bugs formik)
// Prakash 28/10/2022 3075234474 Scheduling UI Enhancements --> ,Added Styling Classes for UI enhancements -->
// akhila 03/11/2022 3075234474 get api integration and data prepopulation
// akhila  11/11/2022 3075234474 fixed validations issues
// akhila 11/11/2022 3075234474 fixed field values bugs
// Prakash  11/11/2022 3075234474 fixed validations Alignments issues.
// akhila 12/11/2022 3075234474 fixed form reset and validation issues.
// akhila  16/11/2022 3075234474 fixed days bug .
// akhila 11/11/2022 3075234474 added new UI Fields for Reports
// Saikrishna 11/30/2022 2701350359  required changes dne for reports
// Sai Maheshwar 11/30/2022 2701350359  removed unwanted code
// Prakash 04/07/2023 2701350359 fixed check box color.

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
} from '@material-ui/core';
import {FormHelperText} from '@mui/material';
import React from 'react';
import reusableInputStyles from '../../../../../components/InputStyles';

const DailyForm = ({
  values,
  setFieldValue,
  handleChange,
  touched,
  errors,
  handleBlur,
  setErrors,
  resetForm,
}) => {
  const classes = reusableInputStyles();

  return (
    <>
      <div className="">
        <FormControl component="fieldset" className={classes.checkBox}>
          <RadioGroup
            aria-label="daily"
            name="daily"
            value={values.daily}
            onChange={(e) => {
              setFieldValue('daily', e.target.value);
            }}
          >
            <div>
              <FormControlLabel
                disabled={values?.runManually}
                value="everyWeekDay"
                name="everyWeekDay"
                control={<Radio />}
                label="Every week day"
                onChange={(e) => {
                  handleChange(e);
                  setFieldValue('dailyNoOfDays', '');
                }}
              />
            </div>
            <div className="d-flex align-items-center form-group">
              <FormControlLabel
                disabled={values?.runManually}
                value="every"
                control={<Radio />}
                label="Every"
              />
              {/* <span className="mr-2">Every</span> */}
              <div>
                <TextField
                  className={classes.textComponent}
                  margin="dense"
                  variant="outlined"
                  placeholder={``}
                  disabled={values.endSchedule === 'runManually' ? true : values.daily !== 'every'}
                  // label="Filter Rule Group Code"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <InputAdornment position="start">
                  //       <span style={{ color: "black" }}>Every</span>
                  //     </InputAdornment>
                  //   ),
                  //   endAdornment: (
                  //     <InputAdornment position="end">
                  //       <span style={{ color: "black" }}>day(s)</span>
                  //     </InputAdornment>
                  //   ),
                  // }}
                  name="dailyNoOfDays"
                  value={values?.dailyNoOfDays}
                  // onChange={handleChange}
                  onChange={(e) => {
                    handleChange(e);
                    setFieldValue('everyWeekDay', '');
                  }}
                  error={Boolean(touched?.dailyNoOfDays && errors?.dailyNoOfDays)}
                  onBlur={handleBlur}
                />
                <FormHelperText margin="dense">
                  {touched.dailyNoOfDays && errors.dailyNoOfDays && errors.dailyNoOfDays}
                </FormHelperText>
              </div>
              <FormLabel className={`ml-2 ${classes.formLabel}`}>days</FormLabel>
            </div>
          </RadioGroup>
        </FormControl>
      </div>
    </>
  );
};

export default DailyForm;
